<template>
  <div class="hero-image">
    <div class="quote-mark quote-mark-left" />
    <div class="quote-mark quote-mark-right" />
    <div class="hero-image-slogan">
      Vor Ort, gut versorgt!
    </div>
  </div>
</template>

<style scoped>
.hero-image {
  margin-top: 63px;
  height: 35vw;
  width: 100vw;
  position: relative;
  background-image: url('../assets/images/mother_child4.jpg');
  background-size: cover;
  background-position: top center;
  text-align: center;
}

.hero-image-slogan {
  position: absolute;
  width: 29vw;
  top: 16%;
  right: 7vw;
  font-size: 3vw;
  font-weight: bold;
  color: var(--primary);
  font-family: 'Montserrat', sans-serif;
}

.quote-mark {
  opacity: 0.2;
  position: absolute;
  height: 5vw;
  width: 5.5vw;
  background-size: cover;
}

.quote-mark-left {
  top: 10%;
  right: 29.5vw;
  background-image: url('../assets/images/quote1.png');
}

.quote-mark-right {
  top: 33.5%;
  right: 10vw;
  background-image: url('../assets/images/quote2.png');
}
</style>
